import api from '../../services/api';

/**
 * Every webhook the platform tried to send, for the internal team. Staff only;
 * anybody else gets a 403. Paginated like the other staff listings:
 * `{ count, results }`.
 *
 * @param {object} params - `page`, `page_size`, and the filters the backend
 *   reads: `admin_id`, `seller_id`, `start_date`, `end_date`, `status`,
 *   `substatus`, `dispatch_state`, `search`.
 */
export const getStaffWebhookHistoryRequest = async (params) => {
  return await api.get('deliveries/staff/webhook_history/', { params });
};

/** Every seller of the platform, as staff reads it: `{ serialized_sellers }`. */
export const getStaffSellersRequest = async () => {
  return await api.get('admins/sellers-list/');
};
